import styled from 'styled-components';

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  img {
    transform: scale(1.01);
  }

  a {
    color: ${({ theme }) => theme.palette.dark};
  }

  &:hover {
    img {
      transform: scale(1.1);
    }

    a {
      color: ${({ theme }) => theme.palette.primary};
    }
  }
`;

export const CardTitle = styled.h3`
  font-size: 16px;
  font-family: Montserrat, Helvetica, sans-serif;
  font-weight: 500;
  margin-top: 5px;
  line-height: 22px;
  margin-bottom: 12px;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 205px;
  overflow: hidden;
  border-radius: 6px;
  margin: 0 auto 8px;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 5px;
    transition: all 0.3s ease;
  }
`;
